import { useQuery } from "@tanstack/react-query";
import { USER_AVAILABLE_DOMAINS } from "../../constants/QueryKeys";
import UserService from "../../service/UserService";
import { getUserId } from "./useAccount";
import { STATIC_QUERY_DEFAULTS } from "../../utils/QueryUtils";

/** @typedef {import("@/types/data/Domain.mjs").AvailableDomain} AvailableDomain */
/** @typedef {{ domains: AvailableDomain[] }} AvailableDomainsData */
/**
 * @template T
 * @typedef {import("@/types/TypeUtils.mjs").QueryResultRest<T>} QueryResultRest
 */
/**
 * @template T
 * @typedef {import("@/types/TypeUtils.mjs").QueryHookOptions<T>} QueryHookOptions
 */

const defaults = STATIC_QUERY_DEFAULTS;

/**
 * Domain suggestions the user can purchase.
 * @param {QueryHookOptions<AvailableDomainsData>} [options] - Extra `useQuery` options, spread over the defaults.
 * @returns {{ availableDomains: AvailableDomain[] | undefined } & QueryResultRest<AvailableDomainsData>}
 */
const useUserAvailableDomains = (options = {}) => {
  const { data, ...rest } = useQuery({
    queryKey: [USER_AVAILABLE_DOMAINS],
    queryFn: () =>
      /** @type {Promise<AvailableDomainsData>} */ (UserService.loadAvailableDomains(getUserId())),
    ...defaults,
    ...options,
  });
  return { availableDomains: data?.domains, ...rest };
};

export default useUserAvailableDomains;
